import React from "react";
import { WalletCards } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useWalletConnect } from "../WalletConnectContext";
import "./WalletConnectControl.css";

export default function WalletConnectControl({ className = "" }) {
  const { t } = useTranslation("staking");
  const { connect } = useWalletConnect() || {};
  const classes = ["staking-wallet-chip", "is-button", className]
    .filter(Boolean)
    .join(" ");

  const handleConnect = async () => {
    await connect?.();
  };

  return (
    <button
      type="button"
      className={classes}
      onClick={handleConnect}
    >
      <WalletCards size={17} />
      <span>{t("common.connectWallet")}</span>
    </button>
  );
}
